<template>
    <div class="h-full w-full flex justify-center items-center">
        <div class="text-center mb-20">
            <div class="flex justify-center">
                <component :is="icon" class="h-12 w-12 text-center text-gray-700 transition duration-500 ease-in-out dark:text-white" aria-hidden="true" />
            </div>
            <h3 v-text="title" class="mt-2 text-sm font-medium text-gray-900 transition duration-500 ease-in-out dark:text-white" />
            <p v-text="subtitle" class="mt-1 text-sm text-gray-500 transition duration-500 ease-in-out dark:text-white" />
            <div class="mt-6">
                <button v-for="action in actions" @click="action.fire()" type="button" class="mx-1 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-900 transition duration-500 ease-in-out dark:bg-gray-800 dark:hover:bg-racing-stars-yellow dark:hover:text-gray-900 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:focus:ring-racing-stars-yellow">
                    <PlusIcon class="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
                    {{ action.text }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { PlusIcon } from '@heroicons/vue/solid'

export default {
    props: {
        subtitle: String,
        title: String,
        actions: Array,
        icon: {}
    },
    components: {
        PlusIcon,
    },
}

</script>
